import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import {
  loadAllAnalyticalNotes,
  loadSingleAnalyticalNote,
} from "./AnalyticalNotesList.slice";

import {
  loadAllAnalyticalNotesAPI,
  loadSingleAnalyticalNoteAPI,
} from "./AnalyticalNotesList.api";

export const LOAD_ALL_ANALYTICAL_NOTES = {
  LOADING: "Load all analytical loading",
  SUCCESS: "Load all analytical success",
  ERROR: "Load all analytical error",
};

export const LOAD_SINGLE_ANALYTICAL_NOTE = {
  LOADING: "Load single analytical loading",
  SUCCESS: "Load single analytical success",
  ERROR: "Load single analytical error",
};

function* loadAllAnalyticalNotesWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllAnalyticalNotesAPI, payload);
    yield put(loadAllAnalyticalNotes(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_ANALYTICAL_NOTES.ERROR, error });
  }
}

function* loadSingleAnalyticalNoteSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleAnalyticalNoteAPI, payload);
    yield put(loadSingleAnalyticalNote(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_ANALYTICAL_NOTE.ERROR, error });
  }
}

export function* loadAllAnalyticalNotesSaga() {
  yield takeLatest(
    LOAD_ALL_ANALYTICAL_NOTES.LOADING,
    loadAllAnalyticalNotesWorker
  );
}

export function* loadSingleAnalyticalNoteSaga() {
  yield takeLatest(
    LOAD_SINGLE_ANALYTICAL_NOTE.LOADING,
    loadSingleAnalyticalNoteSagaWorker
  );
}
